/** 导出 Word：严格 2 页（正面一节、反面一节），纸张=胸卡尺寸 */

import {
  AlignmentType,
  convertMillimetersToTwip,
  Document,
  Packer,
  Paragraph,
  ImageRun,
  TextRun,
} from 'docx'
import { renderBadgePrintImages } from '@/utils/badgeRenderPrint.js'

function mmToTwip(mm) {
  return convertMillimetersToTwip(mm)
}

function mmToImagePx(mm) {
  return Math.round((mm / 25.4) * 96)
}

/** 胸卡画布宽高比（与 badgeRenderPrint 一致） */
function badgeAspect(layoutType) {
  const u = String(layoutType || '').toUpperCase()
  if (u === 'PORTRAIT') return 1 / 1.586
  if (u === 'SQUARE') return 1
  return 1.586
}

/**
 * 计算页面与图片尺寸：保证「标签 + 图片」能落在单页内，避免溢出成 3～5 页
 */
function buildPageSpec(layoutType) {
  const u = String(layoutType || '').toUpperCase()
  const aspect = badgeAspect(layoutType)
  const marginMm = 4
  const labelMm = 4

  let pageWidthMm
  let pageHeightMm
  if (u === 'PORTRAIT') {
    pageWidthMm = 72
    pageHeightMm = 115
  } else if (u === 'SQUARE') {
    pageWidthMm = 92
    pageHeightMm = 92
  } else {
    pageWidthMm = 115
    pageHeightMm = 72
  }

  const innerW = pageWidthMm - marginMm * 2
  const innerH = pageHeightMm - marginMm * 2 - labelMm

  let imgW
  let imgH
  if (innerW / innerH >= aspect) {
    imgH = innerH
    imgW = innerH * aspect
  } else {
    imgW = innerW
    imgH = innerW / aspect
  }

  return {
    pageWidthMm,
    pageHeightMm,
    marginMm,
    imgWidthMm: imgW,
    imgHeightMm: imgH,
  }
}

function dataUrlToUint8Array(dataUrl) {
  const base64 = String(dataUrl || '').split(',')[1] || ''
  const binary = atob(base64)
  const bytes = new Uint8Array(binary.length)
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i)
  }
  return bytes
}

function triggerBlobDownload(blob, filename) {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.rel = 'noopener'
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  setTimeout(() => URL.revokeObjectURL(url), 5000)
}

function sectionProps(spec) {
  const m = spec.marginMm
  return {
    page: {
      size: {
        width: mmToTwip(spec.pageWidthMm),
        height: mmToTwip(spec.pageHeightMm),
      },
      margin: {
        top: mmToTwip(m),
        right: mmToTwip(m),
        bottom: mmToTwip(m),
        left: mmToTwip(m),
      },
    },
  }
}

/** 单页内容：小标题 + 一张图（禁止额外分页） */
function buildPageChildren(dataUrl, spec, label) {
  const buf = dataUrlToUint8Array(dataUrl)
  const imgW = mmToImagePx(spec.imgWidthMm)
  const imgH = mmToImagePx(spec.imgHeightMm)
  return [
    new Paragraph({
      alignment: AlignmentType.CENTER,
      spacing: { before: 0, after: 40 },
      children: [
        new TextRun({
          text: label,
          size: 12,
          color: '999999',
        }),
      ],
    }),
    new Paragraph({
      alignment: AlignmentType.CENTER,
      spacing: { before: 0, after: 0 },
      children: [
        new ImageRun({
          type: 'png',
          data: buf,
          transformation: { width: imgW, height: imgH },
        }),
      ],
    }),
  ]
}

export async function exportBadgeWord(card) {
  if (!card || !card.available) {
    throw new Error('胸卡数据不可用')
  }
  const { front, back } = await renderBadgePrintImages(card)
  const spec = buildPageSpec(card.layoutType)

  const doc = new Document({
    sections: [
      {
        properties: sectionProps(spec),
        children: buildPageChildren(front, spec, '正面'),
      },
      {
        properties: sectionProps(spec),
        children: buildPageChildren(back, spec, '反面'),
      },
    ],
  })

  const blob = await Packer.toBlob(doc)
  const base = String(card.displayName || '胸卡').replace(/[/\\?%*:|"<>]/g, '_')
  triggerBlobDownload(blob, `${base}-胸卡正反面.docx`)

  const u = String(card.layoutType || 'LANDSCAPE').toUpperCase()
  const sizeHint =
    u === 'PORTRAIT' ? '约 72×115 mm' : u === 'SQUARE' ? '约 92×92 mm' : '约 115×72 mm'
  window.alert(
    `已下载 Word，共 2 页，纸张 ${sizeHint}。\n\n` +
      '若 WPS 仍显示多页：在「视图」切到单页查看；打印选实际大小、双面长边翻转。',
  )
}
